import { createContext, useContext, useMemo, type ReactNode } from 'react'
import hu from './hu.json'
import ro from './ro.json'

export type Locale = 'hu' | 'ro'

type Translations = typeof hu

const translations: Record<Locale, Translations> = { hu, ro }

interface LocaleContextValue {
  locale: Locale
  t: Translations
  otherLocale: Locale
}

const LocaleContext = createContext<LocaleContextValue | null>(null)

export function LocaleProvider({ locale, children }: { locale: Locale; children: ReactNode }) {
  const value = useMemo<LocaleContextValue>(
    () => ({
      locale,
      t: translations[locale],
      otherLocale: locale === 'hu' ? 'ro' : 'hu',
    }),
    [locale],
  )

  return <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>
}

export function useLocale() {
  const ctx = useContext(LocaleContext)
  if (!ctx) throw new Error('useLocale must be used within LocaleProvider')
  return ctx
}
